export default "__VITE_ASSET__6EzoHqyX__"